import React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addMessageStart } from '../../redux/Chat/chat.action'

const mapState = (state) => {
    return {
      doctors:state.doctors.doctors,
      currentUser: state.user.currentUser
    }
  }
const isMessageEmpty = (textMessage) => {
    return adjustTextMessage(textMessage).length === 0;
}

const adjustTextMessage = (textMessage) => {
    return textMessage.trim();
};
function ChatForm(props) {
    const [message, setMessage] = useState('');
    const {currentUser} = useSelector(mapState);
    const dispatch = useDispatch();
    const disableButton = isMessageEmpty(message);
    const handleMessage = (e) => {
        e.preventDefault();
        if (!isMessageEmpty(message)) {
            const msgObj = {
                user_name_1: currentUser.displayName,
                user_name_2: props.userName,
                message
            }
            dispatch(addMessageStart(msgObj));
            console.log(msgObj);
             setMessage('');
        }
    }
  return (
    <div className='chat_form'>
        <form onSubmit={handleMessage}>
            <input type="text" placeholder='Text Message' value={message} onChange={(e) =>setMessage(e.target.value)} />
            <button disabled={disableButton} type='submit'>Send</button>
        </form>
    </div>
  )
}

export default ChatForm